<template>
  <recycle-scroller
    class="recycle-scroller-ks scroller"
    :items="items"
    :item-size="itemSize"
    :buffer="buffer"
    :keyField="prop.value"
    v-if="items.length"
  >
    <template v-slot="{ item, active, index }">
      <div
        class="home-ant-select-ppt__item"
        :style="{display: active ? 'flex' : 'none'}"
      >
        <slot :item="item" :active="active" :prop="prop" :index="index"></slot>
      </div>

    </template>
  </recycle-scroller>
</template>

<script>
// https://github.com/Akryum/vue-virtual-scroller
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    RecycleScroller
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    /**
     * itemSize未设置或设置为null，虚拟滚动体将切换到可变大小模式。然后，您需要使用Item元素的大小在Item对象上公开一个Number字段。
     * const items = [ { id: 1, size: 64 },  {id: 2, size: 32},...item ]
     */
    itemSize: {
      type: Number,
      default: null
    },
    buffer: {
      type: Number,
      default: 200
    },
    prop: {
      type: Object,
      defalut: {
        value: 'value',
        text: 'text'
      }
    }
  }
}
</script>

<style lang="less">
.home-ant-select-ppt__item {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: rgba(0, 0, 0, .75);
  &:hover {
    background:#f0f6ff;
    cursor: pointer;
  }
  &.selected {
    color: #0B1019;
    font-weight: 600;
    background-color: #e6f7ff!important;
  }
}
</style>
